export default function goTo(url) {
    window.location.href = url;
}